// Placeholder id until the server responds; nothing may be written against it.
const OPTIMISTIC_ROW_PREFIX = "optimistic-row:";

export function optimisticRowId(index: number): string {
  return `${OPTIMISTIC_ROW_PREFIX}${index}`;
}

export function isOptimisticRow(analysisId: string): boolean {
  return analysisId.startsWith(OPTIMISTIC_ROW_PREFIX);
}
